<template>
  <div v-if="visible" class="radio-group">
    <label v-html="computedLabel" />
    <g-markdown v-if="description" :content="description" />
    <div class="radios" :class="format">
      <RadioChoice
        v-for="(choice, index) in choices"
        :key="index"
        :wide="wide"
        :value="choice.Value"
        :oval="choice.oval ? true : false"
        :selected="isSelected(index)"
        :other="
          !multiple && Object.keys(selected).length > 0 && !isSelected(index)
        "
        @click="onChoiceClick(choice.Value, index)"
      >
        {{ choice.Label }}
      </RadioChoice>
      <RadioChoice
        v-if="other"
        :other="
          !multiple && Object.keys(selected).length > 0 && !isSelected(-1)
        "
        value="other"
        :selected="isSelected(-1)"
        :wide="wide"
        @click="onChoiceClick('', -1)"
      >
        {{ otherLabel || 'Annat' }}
      </RadioChoice>
      <textarea
        v-if="isSelected(-1)"
        v-model="otherTextArea"
        @input="onOtherInput"
      ></textarea>
    </div>
  </div>
</template>

<script>
import RadioChoice from './RadioChoice';
import Vue from 'vue';

export default {
  components: {
    RadioChoice
  },
  props: {
    label: {
      type: String,
      default: () => ''
    },
    choices: {
      type: Array,
      default: () => []
    },
    entity: {
      type: String,
      default: () => ''
    },
    wide: {
      type: Boolean,
      default: false
    },
    description: {
      type: String,
      default: () => null
    },
    required: {
      type: Boolean,
      default: false
    },
    other: {
      type: Boolean,
      default: () => false
    },
    otherLabel: {
      type: String,
      default: () => null
    },
    multiple: {
      type: Boolean,
      default: () => null
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectedIndex: [],
      selected: {},
      otherTextArea: ''
    };
  },
  computed: {
    format() {
      return {
        wide: this.wide
      };
    },
    computedLabel() {
      if (this.required) {
        return '* ' + this.label;
      } else {
        return this.label;
      }
    }
  },
  methods: {
    onChoiceClick(value, index) {
      index = index.toString();
      if (!this.multiple) {
        this.selected = {};
        Vue.set(this.selected, index, value);

        // Check if other option is enabled, if so we don't send the change event for the button press
        if (this.other && index === -1) return;

        this.$emit('change', value, this.entity);

        return;
      }

      // If it does not exist
      if (!this.isSelected(index)) {
        if (index === '-1') {
          value = this.otherTextArea;
        }

        Vue.set(this.selected, index, value);
      } else {
        Vue.delete(this.selected, index);
      }

      this.$emit('change', this.selected, this.entity);
    },
    onOtherInput(event) {
      if (!this.other || !this.isSelected(-1)) {
        return;
      }

      this.selected['-1'] = event.target.value;

      if (this.multiple) {
        this.$emit('change', this.selected, this.entity);
        return;
      }

      this.$emit('change', event.target.value, this.entity);
    },
    isSelected(index) {
      return this.selected.hasOwnProperty(index.toString());
    }
  }
};
</script>

<style lang="scss" scoped>
.radio-group {
  margin: 25px 0;
}

label {
  color: #202020;
  display: block;
  font-size: 18px;
  font-weight: 600;
  line-height: 23px;
  margin: 15px 0;
}

textarea {
  appearance: none;
  border: 0;
  font-family: 'Libre Franklin', Helvetica, Arial, sans-serif;
  font-size: 16px;
  height: 90px;
  margin-bottom: 15px;
  padding: 15px;
  resize: none;
  width: 100%;
}

.radios {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: 0;
  max-width: 420px;

  &.wide {
    flex-flow: column;
    max-width: none;
  }
}
</style>
